<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-beat" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>

<!-- Page Wrapper -->
<div id="wrapper">
  <app-sidebar></app-sidebar>

  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">

    <!-- Main Content -->
    <div id="content">

      <!-- Topbar -->
      <app-header></app-header>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->

      <!-- Begin Page Content -->
      <div class="container-fluid">


        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">Products</h1>
          <a href="javascript:void(0);" class="d-sm-inline-block btn btn-sm btn-primary shadow-sm" (click)="addProduct()"><i class="fas fa-plus fa-sm text-white-50"></i> Add Product</a>
        </div>


        <!-- DataTales Example -->
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h4 class="m-0 font-weight-bold text-primary">Products</h4>
          </div>
          <div class="card-body">
            <!-- <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_length" id="dataTable_length"><label>Show <select name="dataTable_length"
                        aria-controls="dataTable" class="custom-select custom-select-sm form-control form-control-sm select-pagination">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select> entries</label></div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="dataTable_filter" class="dataTables_filter">
                    <label>Search:<input type="search" class="form-control form-control-sm search-box" placeholder=""
                        aria-controls="dataTable"></label>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="table-responsive">


              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Name</th>
                    <th>Category</th>
                    <th>SKU</th>
                    <th>Price</th>
                    <th>Description</th>
                    <th>Image(s)</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of productList; let i=index;">
                    <td width="10%">{{item.payload.doc.data().name}}</td>
                    <td width="10%">{{item.payload.doc.data().category_name}}</td>
                    <td width="10%">{{item.payload.doc.data().sku}}</td>
                    <td width="10%">{{item.payload.doc.data().price_selling}}</td>
                    <td width="30%">{{item.payload.doc.data().description}}</td>
                    <td width="30%">
                      <div  class="product-image-box">
                        <span *ngIf="item.payload.doc.data().pictures && item.payload.doc.data().pictures.length>0 ">
                          <img *ngFor="let img of item.payload.doc.data().pictures" src={{img.download_url}} class="product-img" style="width:30%; margin:1px">
                        </span>  
                      </div>
                      
                    </td>
                    <td width="10%" align="center">
                      <a [routerLink]="['/product',item.payload.doc.id]" class="text-primary" ><i class="fas fa-eye"></i></a> |
                      <a href="javascript:void(0)" class="text-primary" (click)="editProduct(item.payload.doc.id)"><i
                          class="fa fa-fw fa-edit"></i></a> |
                      <a href="javascript:void(0);" class="text-danger" (click)="deleteProduct(item.payload.doc.id)"><i
                          class="fa fa-fw fa-trash"></i></a>
                    </td>

                  </tr>
                  
                </tbody>
              </table>




            </div>
          </div>

        </div>

        <!-- <div class="row">
          <div class="col-sm-12 col-md-5">
            <div class="dataTables_info" id="dataTable_info" role="status" aria-live="polite">Showing 1 to 10 of 57
              entries</div>
          </div>
          <div class="col-sm-12 col-md-7">
            <div class="dataTables_paginate paging_simple_numbers" id="dataTable_paginate">
              <ul class="pagination">
                <li class="paginate_button page-item previous disabled" id="dataTable_previous"><a href="#"
                    aria-controls="dataTable" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>
                <li class="paginate_button page-item active"><a href="#" aria-controls="dataTable" data-dt-idx="1"
                    tabindex="0" class="page-link">1</a></li>
                <li class="paginate_button page-item "><a href="#" aria-controls="dataTable" data-dt-idx="2"
                    tabindex="0" class="page-link">2</a></li>
                <li class="paginate_button page-item "><a href="#" aria-controls="dataTable" data-dt-idx="3"
                    tabindex="0" class="page-link">3</a></li>
                <li class="paginate_button page-item "><a href="#" aria-controls="dataTable" data-dt-idx="4"
                    tabindex="0" class="page-link">4</a></li>
                <li class="paginate_button page-item "><a href="#" aria-controls="dataTable" data-dt-idx="5"
                    tabindex="0" class="page-link">5</a></li>
                <li class="paginate_button page-item "><a href="#" aria-controls="dataTable" data-dt-idx="6"
                    tabindex="0" class="page-link">6</a></li>
                <li class="paginate_button page-item next" id="dataTable_next"><a href="#" aria-controls="dataTable"
                    data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
              </ul>
            </div>
          </div>
        </div> -->

      </div>
      <!-- /.container-fluid -->

      <!-- /.container-fluid -->




    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- End of Footer -->

  </div>
  <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->

<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>



<!-- Modal -->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border-bottom-0 login-sec">
        <h5 class="modal-title" id="exampleModalLabel">Add Product</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form>
        <div class="modal-body">
          <div class="form-group">
            <label for="product">Product Name</label>
            <input type="text" class="form-control" id="Pname">

          </div>
          <div class="form-group">
            <label for="price">Price</label>
            <input type="text" class="form-control" id="price">
          </div>
          <div class="form-group">
            <label for="desc">Description</label>
            <textarea class="form-control" id="desc" rows="3"></textarea>

          </div>
          <div class="form-group">
            <label for="Productimg">Product Image</label>
            <input type="file" class="form-control-file" id="exampleFormControlFile1">
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div> -->


<!--edit modal-->
<!-- <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border-bottom-0 login-sec">
        <h5 class="modal-title" id="exampleModalLabel">Edit Product</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
            <label for="product">Product Name</label>
            <input type="text" class="form-control" id="Pname">
            
          </div>
          <div class="form-group">
            <label for="price">Price</label>
            <input type="text" class="form-control" id="price">
          </div>
          <div class="form-group">
            <label for="desc">Description</label>
            <textarea class="form-control" id="desc" rows="3"></textarea>
  
          </div>
		  <div class="form-group">
           <label for="Productimg">Product Image</label>
           <input type="file" class="form-control-file" id="exampleFormControlFile1">
  </div>
        </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Update</button>
      </div>
    </div>
  </div>
</div> -->
<!--edit modal end-->
  
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">DELETE</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to delete this?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">NO</button>
        <a href="#delete"><button type="button" class="btn btn-primary">YES</button></a>
      </div>
    </div>
  </div>
</div>
  